/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "users-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "accomplishments-prod",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "tyc-questions-bucket170910-prod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:d1cd194c-b07c-46f2-a3da-78f3576373b9",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_MIKfgf1mD",
    "aws_user_pools_web_client_id": "192r79emb9injcuqtjoi3nhmrn",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "gencertapi",
            "endpoint": "https://mqmq9cmo61.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "userapi",
            "endpoint": "https://6s1xapg0el.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "accomplishmentsapi",
            "endpoint": "https://ojkvyezwyc.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "discordapi",
            "endpoint": "https://38nsscsz14.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
